import { render } from "./Documents.vue?vue&type=template&id=e087fe12"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
script.render = render

export default script